export default __webpack_public_path__ + "static/media/mastercardHd.49963fd0.svg";